import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

interface TreasurerWelcomeModalProps {
  open: boolean;
  firstName: string;
  onDismiss: (markSeen: boolean) => void;
}

const steps = [
  "Set your financial year start and end date in Settings.",
  "Set the minimum balance to keep in your bank account in Settings.",
  "Set up your Cash Floats in the Cash Floats tab.",
  "Add anyone with bank access in the Bank Access tab.",
  "Configure any Alerts that will be useful to you.",
];

export function TreasurerWelcomeModal({ open, firstName, onDismiss }: TreasurerWelcomeModalProps) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onDismiss(false); }}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Welcome{firstName ? `, ${firstName}` : ""}!</DialogTitle>
          <DialogDescription>
            Let's get your Treasurer Dashboard set up. Here are a few important things to do first:
          </DialogDescription>
        </DialogHeader>
        <ul className="space-y-3 py-2">
          {steps.map((step, i) => (
            <li key={i} className="flex gap-3 text-sm">
              <CheckCircle2 className="h-5 w-5 text-primary shrink-0 mt-0.5" />
              <span>{step}</span>
            </li>
          ))}
        </ul>
        <DialogFooter className="gap-2">
          <Button variant="ghost" onClick={() => onDismiss(false)}>Remind me later</Button>
          <Button onClick={() => onDismiss(true)}>Got it</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
